
import _, { isEmpty } from 'lodash';
import React from 'react';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';

const FieldConsignPayment = ({
  values,
  products,
  setValues,
}) => {
  const { isTradePrice } = values;
  React.useEffect(() => {
    switch (values?.consignPaymentMethod?.method) {
      case 'lowestItemPrice':
        {
          const lowestPriceItem = _.minBy(products, (x) => Number(isTradePrice
            ? x.item.prices.tradePrice
            : x.item.prices.retailPrice));
          setValues((v) => ({
            ...v,
            consignPaymentMethod: {
              method: 'lowestItemPrice',
              item: lowestPriceItem?.item._id,
              amount: isTradePrice
                ? lowestPriceItem?.item.prices.tradePrice
                : lowestPriceItem?.item.prices.retailPrice,
            },
          }));
        }
        break;
      case 'itemPrice':
        {
          const item = _.find(products, (x) => x.item._id === values?.consignPaymentMethod?.item);
          setValues((v) => ({
            ...v,
            consignPaymentMethod: {
              method: 'itemPrice',
              item: item?.item._id,
              amount: isTradePrice
                ? item?.item.prices.tradePrice
                : item?.item.prices.retailPrice,
            },
          }));
        }
        break;
      default: break;
    }
  }, [
    values?.consignPaymentMethod?.method,
    values?.consignPaymentMethod?.item,
    products,
  ]);
  React.useEffect(() => {
    setValues((v) => ({
      ...v,
      consignCustAmt: values?.consignPaymentMethod?.amount ?? '0',
    }));
  }, [values?.consignPaymentMethod?.amount]);
  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
        Consignment Payment Method
      </h6>

      <div className="row">
        <div className="col">
          <FormGroup
            name='consignPaymentMethod.method'
            label="Method"
            as="select">

            <option value=""> - </option>
            {
              Object.keys(env.consignPaymentType ?? {})
                .map((k) => (<option key={k} value={k}>
                  {env.consignPaymentType?.[k] ?? ''}
                </option>))
            }

          </FormGroup>
        </div>
      </div>
      {values?.consignPaymentMethod?.method === 'itemPrice' && (
        <div className="row">
          <div className="col">
            <FormGroup
              name={'consignPaymentMethod.item'}
              type="number"
              label="Items"
              as="select">
              <option value=""> - </option>
              {(values?.items ?? []).map((item, index) => {
                const {
                  _id, design, serialNo, size, prices,
                } = item.item;
                let label = design;

                if (design && typeof design !== 'string') {
                  label = design.design;
                }

                if (isEmpty(label)) {
                  label = serialNo;
                } else {
                  label += ` (${serialNo})`;
                }

                if (size) {
                  label += ` - ${size}`;
                }
                const price = isTradePrice ? prices.tradePrice : prices.retailPrice;

                if (price) {
                  label += ` - ${prices.currency} ${price}`;
                }

                return (
                  <option key={index} value={_id}>
                    {label}
                  </option>
                );
              })}
            </FormGroup>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col">
          <FormGroup
            name='consignPaymentMethod.amount'
            type="number"
            label="Amount"
            disabled={values.consignPaymentMethod.method !== 'customPrice'}
          />
        </div>
      </div >

      {/* <FormGroup name="consignCustAmt" type="number" label="Custom Consign Amount" /> */}
    </>

  );
};

export default FieldConsignPayment;
